export default (messages, message_index) => {
    messages = messages.filter((message, i) => { return i !== message_index })

    // length === 0 check
    if (messages.length === 0) {
      messages = null
    }

    return messages
}